<template>
    <div class="lead lead__text"><span class="lead__ligature">{{ ligature }}</span>
    <p v-html="text"></p>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters([
                'content'
            ]),
            ligature() {
                return this.content.leadText.charAt(0)
            },
            text() {
                return this.content.leadText.substr(1, this.content.leadText.length - 1)
            }
        }
    }
</script>

<style lang="scss">
    .lead-text-container {
        margin-top: 60px;
    }
</style>


